import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { targetsFetchList } from './targetsFetchList';

import { ITargetsStore } from '../../types';
import { IActionTargetsFetchListPayloadDone } from './types';

export const targetsFetchListReducer = (projects: ReducerBuilder<ITargetsStore, ITargetsStore>) => {
	applyAsyncReducer<ITargetsStore['targets']['data'], ITargetsStore['targets']['meta']>()(
		'targets',
		'networkStatus',
		targetsFetchList.async,
		projects,
		(props: { result: IActionTargetsFetchListPayloadDone }) => ({
			list: props.result.targets,
		}),
	);
};
